import { ClientDocument, DocumentFolder } from '../../components/library/documents/types';

const DOCUMENT = 'DOCUMENTS';
const FOLDER = 'DOCUMENT_FOLDERS';

const actions = {
  LOAD_DOCUMENTS: DOCUMENT + '_LOAD',
  LOAD_DOCUMENTS_SUCCESS: DOCUMENT + '_LOAD_SUCCESS',
  LOAD_DOCUMENTS_ERROR: DOCUMENT + '_LOAD_ERROR',

  UPLOAD_DOCUMENT: DOCUMENT + '_UPLOAD',
  UPLOAD_DOCUMENT_SUCCESS: DOCUMENT + '_UPLOAD_SUCCESS',
  UPLOAD_DOCUMENT_ERROR: DOCUMENT + '_UPLOAD_ERROR',

  DELETE_DOCUMENT: DOCUMENT + '_DELETE',
  DELETE_DOCUMENT_SUCCESS: DOCUMENT + '_DELETE_SUCCESS',
  DELETE_DOCUMENT_ERROR: DOCUMENT + '_DELETE_ERROR',

  LOAD_FOLDERS: FOLDER + '_LOAD',
  LOAD_FOLDERS_SUCCESS: FOLDER + '_LOAD_SUCCESS',
  LOAD_FOLDERS_ERROR: FOLDER + '_LOAD_ERROR',

  CREATE_FOLDER: FOLDER + '_CREATE',
  CREATE_FOLDER_SUCCESS: FOLDER + '_CREATE_SUCCESS',
  CREATE_FOLDER_ERROR: FOLDER + '_CREATE_ERROR',

  DELETE_FOLDER: FOLDER + '_DELETE',
  DELETE_FOLDER_SUCCESS: FOLDER + '_DELETE_SUCCESS',
  DELETE_FOLDER_ERROR: FOLDER + '_DELETE_ERROR',

  NOTIFY_CLIENT_UPLOADS: DOCUMENT + '_NOTIFY_CLIENT_UPLOADS',

  loadDocuments: (clientId: string) => ({
    type: actions.LOAD_DOCUMENTS,
    payload: { clientId },
  }),

  loadDocumentsSuccess: (documents: ClientDocument[]) => ({
    type: actions.LOAD_DOCUMENTS_SUCCESS,
    payload: { documents },
  }),

  loadDocumentsError: (error: string) => ({
    type: actions.LOAD_DOCUMENTS_ERROR,
    payload: { error },
  }),

  uploadDocument: (payload: { clientId: string; file: File; folderId: string | null }) => ({
    type: actions.UPLOAD_DOCUMENT,
    payload,
  }),

  uploadDocumentSuccess: (document: ClientDocument) => ({
    type: actions.UPLOAD_DOCUMENT_SUCCESS,
    payload: { document },
  }),

  uploadDocumentError: (error: string) => ({
    type: actions.UPLOAD_DOCUMENT_ERROR,
    payload: { error },
  }),

  deleteDocument: (payload: { id: string; storagePath: string }) => ({
    type: actions.DELETE_DOCUMENT,
    payload,
  }),

  deleteDocumentSuccess: (id: string) => ({
    type: actions.DELETE_DOCUMENT_SUCCESS,
    payload: { id },
  }),

  deleteDocumentError: (error: string) => ({
    type: actions.DELETE_DOCUMENT_ERROR,
    payload: { error },
  }),

  loadFolders: (clientId: string) => ({
    type: actions.LOAD_FOLDERS,
    payload: { clientId },
  }),

  loadFoldersSuccess: (folders: DocumentFolder[]) => ({
    type: actions.LOAD_FOLDERS_SUCCESS,
    payload: { folders },
  }),

  loadFoldersError: (error: string) => ({
    type: actions.LOAD_FOLDERS_ERROR,
    payload: { error },
  }),

  createFolder: (payload: { clientId: string; parentId: string | null; name: string }) => ({
    type: actions.CREATE_FOLDER,
    payload,
  }),

  createFolderSuccess: (folder: DocumentFolder) => ({
    type: actions.CREATE_FOLDER_SUCCESS,
    payload: { folder },
  }),

  createFolderError: (error: string) => ({
    type: actions.CREATE_FOLDER_ERROR,
    payload: { error },
  }),

  deleteFolder: (payload: {
    folder: DocumentFolder;
    allFolders: DocumentFolder[];
    allDocuments: ClientDocument[];
  }) => ({
    type: actions.DELETE_FOLDER,
    payload,
  }),

  deleteFolderSuccess: (folderId: string) => ({
    type: actions.DELETE_FOLDER_SUCCESS,
    payload: { folderId },
  }),

  deleteFolderError: (error: string) => ({
    type: actions.DELETE_FOLDER_ERROR,
    payload: { error },
  }),

  notifyClientUploads: (payload: { clientId: string; documents: Array<{ name: string; folderName?: string }>; subject?: string; message?: string; to?: string }) => ({
    type: actions.NOTIFY_CLIENT_UPLOADS,
    payload,
  }),
};

export default actions;
